import { registerSW } from 'virtual:pwa-register'

export function registerServiceWorker() {
  if (import.meta.env.VITE_SERVICE_WORKER_ACTIVATED !== 'true') {
    console.log('[Service Worker] Registration is disabled via VITE_SERVICE_WORKER_ACTIVATED environment variable.')
    return
  }
  if (!('serviceWorker' in navigator)) {
    console.warn('[Service Worker] Not supported in this browser!')
    return
  }

  registerSW({
    async onRegisteredSW (swScriptUrl, registration) {
      console.log('[Service Worker] Registered: ', swScriptUrl)

      // When live update via @capawesome/capacitor-live-update is enabled, the SW update logic is disabled.
      // See also apps/sdui-app/config/pwaViteConfig.ts
      if (import.meta.env.VITE_LIVE_UPDATE_ENABLED === 'true') {
        return
      }

      const silentlyUpdateSW = async () => {
        try {
          if (registration) {
            console.log('[Service Worker] Checking for new deployment...')
            await registration.update()
          }
        } catch {
          // silently catch this error
          // this will always happen if our servers are unavailable, for example in the short amount of time when
          // release is being deployed
        }
      }

      // directly check for update once to avoid waiting 60s after app startup
      await silentlyUpdateSW()
      // then check every 60 seconds for update
      setInterval(() => {
        silentlyUpdateSW()
      }, 60000)
    },

    onRegisterError (error) {
      console.warn('[Service Worker] Error during registration: ', error)
    },
    onOfflineReady () {
      console.log('[Service Worker] App is ready to work offline.')
    }
  })
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.unregister().then(success => {
          if (success) return console.log('[Service Worker] Successfully unregistered.')
          console.warn('[Service Worker] Could not unregister!')
        }).catch(err => console.warn('[Service Worker] Unregister failed:', err))
      }
    }).catch(err => console.warn('[Service Worker] getRegistrations failed:', err))
  }
}
